import { useState } from "react";
import { faqs } from "@/mocks/guagua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs md:text-sm font-medium tracking-wide text-primary-500">❓ 别急着走</p>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
            常见问题 · 想知道的都在这里
          </h2>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-2xl bg-background-100 border border-background-200">
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3 text-sm md:text-base font-medium text-foreground-950">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 text-xs">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`ri-add-line text-xl text-foreground-400 transition-transform ${open ? "rotate-45" : ""}`}
                  ></i>
                </button>
                {open && (
                  <p className="px-5 pb-5 pl-[3.75rem] text-sm leading-relaxed text-foreground-700">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}